// extracted by mini-css-extract-plugin
export default {"error":"TextInput_error__V0AED","errorMessage":"TextInput_errorMessage__OpRPW"};